(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioVisualizacaoController', PropostareceituarioVisualizacaoController);

    PropostareceituarioVisualizacaoController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'Propostareceituario', 'Propriedade', 'Safra', 'Atributo', 'Concentracaoidealatributo', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Receituario', 'ParseLinks', 'AlertService'];

    function PropostareceituarioVisualizacaoController($scope, $rootScope, $stateParams, previousState, Propostareceituario, Propriedade, Safra, Atributo, Concentracaoidealatributo, Concentracaoindice, Imagemtermica, Mapaimagem, Receituario, ParseLinks, AlertService) {
        var vm = this;
        vm.propostas = [];
        vm.idmapa = $stateParams.idmapa;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.itemsPerPage = 10000;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.fileURL;
        vm.carregando=true;
        vm.primeira = true;
        vm.loadMapa = loadMapa;

        loadMapa();
        loadAll();

        function loadMapa(){

           

            Propostareceituario.queryMapa({
                idmapa: parseInt(vm.idmapa)
            }, sucessoMapa, erroMapa);

            function sucessoMapa(data){


                var conteudo = data[0];
                var imagemContentType =conteudo.imagempequenaContentType;
                var imagem = conteudo.imagempequena;
                vm.fileURL = 'data:' + imagemContentType +';base64,' + imagem;
                vm.carregando = false;
                console.log("Imagem lida com sucesso");
                
            }

            function erroMapa(){
                console.log("Erro na leitura do mapa");
            }

        }

        
       


        function loadAll () {    
            

            if (vm.currentSearch) {
                Propostareceituario.queryPropostaByMapa({
                    idmapa: parseInt(vm.idmapa),
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Propostareceituario.queryPropostaByMapa({
                    idmapa:  parseInt(vm.idmapa),
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        


            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.propostas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            
        }

        function reset () {
            vm.page = 0;
            vm.propostas = [];
            loadAll();
        }

        function loadPage(page) {
            console.log("infinite");
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.propostas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.propostas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }


        
    }
})();
